import { useState } from "react"
import { getVoiceNoteText, updateVoiceNoteTranscript } from "../service/isolatedScanService"
import { IsolatedScanTHzMetadata, IsolatedScanVoiceNoteText, StarAPIFetchState, UserResponse } from "../types/types"
import { getUser } from "../service/userService"
import { showErrorToast } from "../utils/utils"
import { IsolatedScan } from "../types/starAPIResponseTypes"

const useVoiceNotes = () => {

  const [voiceNote, setVoiceNote] = useState<StarAPIFetchState<IsolatedScanVoiceNoteText>>({ status: "idle"})

  const onLoadVoiceNoteText = async (isolatedScanId: number, userId: number) => {
    setVoiceNote({ status: "loading" })

    const userResponse = await getUser(userId)
    if (userResponse instanceof Error) {
      setVoiceNote({ status: "error", error: userResponse })
      return
    }    

    const response = await getVoiceNoteText(isolatedScanId)    

    if (response instanceof Error) {
      if (response.cause === "404") {
        setVoiceNote({ status: "success", data: null })
        return
      }
      setVoiceNote({ status: "error", error: response })
      return
    }

    const scanVoiceNote = { id: isolatedScanId, user: userResponse as UserResponse }
    
    if ("edits" in response) {
      setVoiceNote({ status: "success", data: {...scanVoiceNote, text: response["edits"][0] }})
      return
    }

    const combinedPhrases = response["combinedPhrases"]

    if (combinedPhrases.length === 0) {
      setVoiceNote({ status: "success", data: {...scanVoiceNote, text: "Could not get transcription for audio." }})
      return
    }

    const transcription = combinedPhrases[0]["text"]
    if (transcription === undefined) {
      setVoiceNote({ status: "success", data: {...scanVoiceNote, text: "Could not get transcription for audio." }})
      return
    }

    if (transcription === "") {
      setVoiceNote({ status: "success", data: {...scanVoiceNote, text: "No speech detected." }})
      return
    }

    setVoiceNote({ status: "success", data: {...scanVoiceNote, text: transcription }})
  }

  const onEditVoiceNoteTranscription = async (editedText: string, isolatedScan?: IsolatedScan) => {
    if (isolatedScan === undefined) { return }
    const response = await updateVoiceNoteTranscript(isolatedScan, editedText)
    if (response instanceof Error) {
      showErrorToast(`Failed to update voice note transcript. ${response.message}`)
      return
    }    
  }

  return [{
    voiceNoteText: voiceNote,
    onLoadVoiceNoteText,
    onEditVoiceNoteTranscription
  }]


}

export default useVoiceNotes